import { render, staticRenderFns } from "./ScrollText.vue?vue&type=template&id=50e13ff0"
import script from "./ScrollText.vue?vue&type=script&lang=js"
export * from "./ScrollText.vue?vue&type=script&lang=js"
import style0 from "./ScrollText.vue?vue&type=style&index=0&id=50e13ff0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports